import { render, staticRenderFns } from "./GuncellemeNotlari.vue?vue&type=template&id=361e9606&scoped=true&"
import script from "./GuncellemeNotlari.vue?vue&type=script&lang=js&"
export * from "./GuncellemeNotlari.vue?vue&type=script&lang=js&"
import style0 from "./GuncellemeNotlari.vue?vue&type=style&index=0&id=361e9606&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e9606",
  null
  
)

export default component.exports